/**
 * RelationshipToPerson entity model class
 *
 * This file is part of ePlan
 * (c) Kaden und Partner AG
 */
import { BaseModel } from '@/models/BaseModel';
import { BaseCollection } from './BaseCollection';

export const ROLE = {
    APPLICANT: 'applicant',
    PROJECT_AUTHOR: 'project author',
    CLERK: 'clerk',
    LANDOWNER: 'landowner',
    INVOICE_RECIPIENT: 'invoice recipient',
    GEOTHERMICS_PLANNING_OFFICE: 'geothermics planning office',
    HYDROGEOLOGICAL_CONSTRUCTION_SUPERVISION: 'hydrogeological construction supervision'
};

export const TYPE = {
    PERSON: 'person',
    ORGANISATION: 'organisation'
};

export class RelationshipToPerson extends BaseModel {
    public id: number | null = null;
    public planning_permission_application_id: number | null = null;
    public role: string | null = null;
    public address_type: string | null = null;
    public mr_mrs: string | null = null;
    public title: string | null = null;
    public first_name: string | null = null;
    public last_name: string | null = null;
    public address_line_1: string | null = null;
    public address_line_2: string | null = null;
    public street: string | null = null;
    public house_number: string | null = null;
    public dwelling_number: string | null = null;
    public post_office_box: number | null = null;
    public post_office_box_text: string | null = null;
    public swiss_zip_code: number | null = null;
    public swiss_zip_code_add_on: string | null = null;
    public swiss_zip_code_id: number | null = null;
    public foreign_zip_code: string | null = null;
    public locality: string | null = null;
    public town: string | null = null;
    public zip_town_ident: string | null = null;
    public country_id: number | null = null;
    public organisation_name: string | null = null;
    public organisation_name_add_on_1: string | null = null;
    public organisation_name_add_on_2: string | null = null;
    public email: string | null = null;
    public phone: string | null = null;
    public name_text: string | null = null;
    public country_short_name_de: string | null = null;
    public country_iso2_id: number | null = null;
    public zip_town: string | null = null;

    mutations() {
        return {
            id: (id: number | null) => (Number(id) > 0 ? Number(id) : null)
        };
    }

    getClassName(): string {
        return 'RelationshipToPerson';
    }
}

export class RelationshipToPersonCollection extends BaseCollection<RelationshipToPerson> {
    protected modelCls = RelationshipToPerson;

    public getModelClassName(): string {
        return 'RelationshipToPerson';
    }
}
